import 'firebase/auth';

export default {
  parentMenuCategories: [],
};
